"use client"

import { useEffect } from "react"

/**
 * Global error boundary (app-level).
 * In Next.js, this catches errors that escape route-level error boundaries.
 * Required for errors during RSC streaming / hydration recovery.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.warn("[GlobalError] Auto-recovering from:", error.message)
    const timer = setTimeout(() => reset(), 150)
    return () => clearTimeout(timer)
  }, [error, reset])

  // Minimal shell to avoid blank page
  return (
    <html>
      <body />
    </html>
  )
}
